import { useEffect, useRef } from "react";
import {
  fetchRequestsByEntityID,
} from "../../state/slices/reportqueue";
import { useDispatch } from "react-redux";

//TODO: understand why we are doing this?
const useReportQueueListener = ({ entityID,facilityGroupID }) => {
  const dispatch = useDispatch();
 
  const entityIDRef = useRef(entityID); // Store entityID persistently

  useEffect(() => {
    entityIDRef.current = entityID; // Update ref when entityID changes
  }, [entityID]);

  const getEntityReportQueueData = () => {
    dispatch(fetchRequestsByEntityID(entityIDRef.current));
  };

  return {
    getEntityReportQueueData,
  };
};

export default useReportQueueListener;
